import { client } from '../http';

async function fetchCreditCardQuestions() {
  const response = await client.get('/api/investigator/onboarding/questions/cc');
  return response.data;
}

export default {
  fetchCreditCardQuestions,
};



// WEBPACK FOOTER //
// ./src/api/CreditCardQuestionsApi.js